<template>
  <section
    class="flex flex-col items-center justify-center bg-[#EEFAF6]"
    id="help"
  >
    <h2
      class="relative mx-10 mt-16 text-center text-[32px] font-bold uppercase"
    >
      S čím pomáhám
      <span
        class="absolute bottom-[-35px] left-1/2 h-1 w-10 -translate-x-1/2 transform bg-primary"
      ></span>
    </h2>
    <p class="mx-10 my-20 max-w-4xl text-center leading-6" data-aos="fade">
      V rámci psychoterapie Vám mohu poskytnout podporu ve chvílích, kdy to nejvíc
      potřebujete. Sdílená starost je poloviční starost – a už samotný rozhovor
      je prvním krokem k nalezení klidu a životní rovnováhy. Nabízím Vám
      bezpečný prostor, kde můžete otevřeně sdílet své myšlenky a pocity.
      <br><br>
      Naše setkání můžeme realizovat osobně nebo online formou.
    </p>
    <div
      class="mx-10 mb-20 grid max-w-5xl grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-3"
    >
      <div
        v-for="(card, index) in cards"
        :key="index"
        data-aos="fade"
        :data-aos-delay="index * 200"
        class="row-span-2 grid grid-rows-subgrid gap-4 rounded-3xl rounded-br-none bg-[#b0e6d5] px-4 py-5 text-center"
      >
        <span
          class="mx-auto flex h-12 w-12 grid-rows-subgrid items-center justify-center rounded-full bg-[#59c1a1] font-bold text-[#f4ffff]"
        >
          {{ index + 1 }}
        </span>
        <div class="grid-rows-subgrid">{{ card.title }}</div>
      </div>
    </div>
  </section>
</template>

<script setup>
const cards = [
  { title: "s úzkostí" },
  { title: "s traumaty" },
  { title: "s depresí" },
  { title: "se ztrátou" },
  { title: "se vztahovými a rodinnými konflikty" },
  { title: "s rozvodovými konflikty" },
];
</script>

<style scoped></style>
